import { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const IRS_RATE = 0.70;

export default function NewTripManual() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const [trip, setTrip] = useState({
    startAddress: '',
    endAddress: '',
    distance: '',
    date: new Date().toISOString().split('T')[0],
    purpose: 'Business',
    notes: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  function updateField(field, value) {
    setTrip((prev) => ({ ...prev, [field]: value }));
  }

  async function handleSave() {
    if (!trip.distance || parseFloat(trip.distance) <= 0) {
      setError('Please enter the trip distance.');
      return;
    }
    if (!trip.startAddress && !trip.endAddress) {
      setError('Please enter at least a start or end location.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      const dist = parseFloat(trip.distance);
      await addDoc(collection(db, 'users', currentUser.uid, 'trips'), {
        date: new Date(trip.date + 'T12:00:00').toISOString(),
        startAddress: trip.startAddress.slice(0, 200),
        endAddress: trip.endAddress.slice(0, 200),
        distance: dist,
        deduction: parseFloat((dist * IRS_RATE).toFixed(2)),
        irsRate: IRS_RATE,
        purpose: trip.purpose,
        notes: trip.notes.slice(0, 500),
        trackingMethod: 'manual',
        createdAt: new Date().toISOString(),
      });
      navigate('/dashboard');
    } catch (err) {
      setError('Failed to save trip. Please try again.');
      console.error('Save error:', err);
    }
    setSaving(false);
  }

  return (
    <div className="screen-container">
      <h2>Log a Trip</h2>

      {error && <div className="error-message">{error}</div>}

      <div className="manual-trip-form">
        <div className="trip-route-fields">
          <div className="route-field">
            <div className="route-dot start" />
            <div className="form-group">
              <input
                type="text"
                value={trip.startAddress}
                onChange={(e) => updateField('startAddress', e.target.value)}
                placeholder="Start location"
              />
            </div>
          </div>
          <div className="route-line" />
          <div className="route-field">
            <div className="route-dot end" />
            <div className="form-group">
              <input
                type="text"
                value={trip.endAddress}
                onChange={(e) => updateField('endAddress', e.target.value)}
                placeholder="End location"
              />
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Distance (miles)</label>
            <input
              type="number"
              value={trip.distance}
              onChange={(e) => updateField('distance', e.target.value)}
              placeholder="0.0"
              step="0.1"
              min="0"
            />
          </div>
          <div className="form-group">
            <label>Date</label>
            <input
              type="date"
              value={trip.date}
              onChange={(e) => updateField('date', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label>Purpose</label>
          <div className="purpose-toggle">
            <button
              className={`purpose-btn ${trip.purpose === 'Business' ? 'active' : ''}`}
              onClick={() => updateField('purpose', 'Business')}
              type="button"
            >
              Business
            </button>
            <button
              className={`purpose-btn ${trip.purpose === 'Personal' ? 'active' : ''}`}
              onClick={() => updateField('purpose', 'Personal')}
              type="button"
            >
              Personal
            </button>
            <button
              className={`purpose-btn ${trip.purpose === 'Medical' ? 'active' : ''}`}
              onClick={() => updateField('purpose', 'Medical')}
              type="button"
            >
              Medical
            </button>
            <button
              className={`purpose-btn ${trip.purpose === 'Charity' ? 'active' : ''}`}
              onClick={() => updateField('purpose', 'Charity')}
              type="button"
            >
              Charity
            </button>
          </div>
        </div>

        {trip.distance && parseFloat(trip.distance) > 0 && (
          <div className="manual-deduction-preview">
            <span>Estimated Deduction</span>
            <span className="deduction-amount">${(parseFloat(trip.distance) * IRS_RATE).toFixed(2)}</span>
          </div>
        )}

        <div className="form-group">
          <label>Notes (optional)</label>
          <input
            type="text"
            value={trip.notes}
            onChange={(e) => updateField('notes', e.target.value)}
            placeholder="Client name, trip purpose, etc."
          />
        </div>

        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save Trip'}
        </button>
        <button className="btn btn-secondary" onClick={() => navigate('/dashboard')} style={{ marginTop: '8px' }}>
          Cancel
        </button>
      </div>
    </div>
  );
}
